var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "-0.02 -0.5 48 49",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 .75C11.156.75.75 11.156.75 24S11.156 47.25 24 47.25 47.25 36.844 47.25 24 36.844.75 24 .75zm0 42C13.64 42.75 5.25 34.36 5.25 24S13.64 5.25 24 5.25 42.75 13.64 42.75 24 34.36 42.75 24 42.75zm5.794-9.788-7.96-5.784a1.132 1.132 0 0 1-.459-.91V10.876c0-.619.506-1.125 1.125-1.125h3c.619 0 1.125.506 1.125 1.125v13.284l6.263 4.557c.506.365.609 1.068.243 1.575l-1.762 2.428a1.133 1.133 0 0 1-1.575.243z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.fe878133026c3bf193d2ca4682700de1.svg";
export { ForwardRef as ReactComponent };